export default __webpack_public_path__ + "static/media/Standard18.2ae377e7.png";